<template>
  <v-container 
    :class="customClass" 
    v-bind="$props" 
    v-on="$listeners"
  >
    <slot />
  </v-container>
</template>

<script>
import { VContainer } from "vuetify/lib";

export default {
  name: "WorkContainer",
  props: {
    ...VContainer.options.props,
    rootContainer: { type: Boolean, default: true },
  },
  computed: {
    customClass() {
      return {
        'w-container': !this.rootContainer,
        'w-container__root': this.rootContainer,
      };
    }
  }
};
</script>

<style lang="scss">
.w-container__root {
  padding: 0;
}
</style>
